/* Heritage Quick View — modal driven by /products/{handle}.js */
(function () {
  'use strict';

  const formatMoney = (cents) => {
    const trCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'TRY';
    const value = (cents / 100);
    return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: trCurrency, minimumFractionDigits: 2 }).format(value);
  };

  const cache = {};

  let modal = null;
  let elements = null;

  function getModal() {
    if (modal) return modal;
    modal = document.getElementById('quick-view-modal');
    if (!modal) return null;
    elements = {
      backdrop: modal.querySelector('.qv-modal__backdrop'),
      closeBtns: modal.querySelectorAll('[data-qv-close]'),
      loading: modal.querySelector('[data-qv-loading]'),
      content: modal.querySelector('[data-qv-content]'),
      footer: modal.querySelector('[data-qv-footer]'),
      vendor: modal.querySelector('[data-qv-vendor]'),
      images: modal.querySelector('[data-qv-images]'),
      title: modal.querySelector('[data-qv-title]'),
      productVendor: modal.querySelector('[data-qv-product-vendor]'),
      priceRow: modal.querySelector('[data-qv-price-row]'),
      options: modal.querySelector('[data-qv-options]'),
      inventory: modal.querySelector('[data-qv-inventory]'),
      atc: modal.querySelector('[data-qv-add-to-cart]'),
      atcLabel: modal.querySelector('[data-qv-atc-label]'),
      detailLink: modal.querySelector('[data-qv-detail-link]'),
    };
    elements.closeBtns.forEach((b) => b.addEventListener('click', closeModal));
    elements.atc.addEventListener('click', handleAddToCart);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
    return modal;
  }

  function openModal() {
    const m = getModal();
    if (!m) return;
    m.hidden = false;
    m.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => m.classList.add('is-open'));
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    setTimeout(() => {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }, 250);
  }

  async function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Failed to load product: ${res.status}`);
    const data = await res.json();
    cache[handle] = data;
    return data;
  }

  let currentProduct = null;
  let currentVariant = null;

  function renderProduct(product, productUrl) {
    currentProduct = product;
    currentVariant = product.variants.find((v) => v.available) || product.variants[0];

    elements.vendor.textContent = product.vendor || '';
    elements.productVendor.textContent = product.vendor || '';
    elements.title.textContent = product.title;
    elements.detailLink.href = productUrl || `/products/${product.handle}`;

    elements.images.innerHTML = '';
    (product.media && product.media.length ? product.media : product.images.map((src) => ({ preview_image: { src } }))).forEach((m, i) => {
      const src = (m.preview_image && m.preview_image.src) || m.src || m;
      if (!src) return;
      const img = document.createElement('img');
      img.src = src.replace(/\.(jpg|jpeg|png|webp|gif)(\?|$)/i, '_400x.$1$2');
      img.alt = `${product.title} - ${i + 1}`;
      img.loading = i === 0 ? 'eager' : 'lazy';
      elements.images.appendChild(img);
    });

    elements.options.innerHTML = '';
    if (product.options && product.options.length && !(product.options.length === 1 && product.options[0].name === 'Title')) {
      product.options.forEach((opt, idx) => {
        const group = document.createElement('div');
        group.className = 'qv-modal__opt-group';
        const label = document.createElement('p');
        label.className = 'qv-modal__opt-label';
        label.innerHTML = `<strong>${opt.name}:</strong> <span data-qv-opt-current="${idx}">${currentVariant.options[idx] || ''}</span>`;
        group.appendChild(label);

        const list = document.createElement('div');
        list.className = 'qv-modal__opt-list';
        opt.values.forEach((val) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'qv-modal__opt-btn';
          btn.dataset.optionIndex = idx;
          btn.dataset.optionValue = val;
          btn.textContent = val;
          if (currentVariant.options[idx] === val) btn.classList.add('is-selected');
          btn.addEventListener('click', () => selectOption(idx, val));
          list.appendChild(btn);
        });
        group.appendChild(list);
        elements.options.appendChild(group);
      });
    }

    updatePrice();
    updateAvailability();
  }

  function selectOption(index, value) {
    if (!currentProduct) return;
    const currentOpts = [...currentVariant.options];
    currentOpts[index] = value;
    const match = currentProduct.variants.find((v) => v.options.every((o, i) => o === currentOpts[i]));
    if (match) {
      currentVariant = match;
      elements.options.querySelectorAll('.qv-modal__opt-btn').forEach((b) => {
        if (parseInt(b.dataset.optionIndex, 10) === index) {
          b.classList.toggle('is-selected', b.dataset.optionValue === value);
        }
      });
      const labelSpan = elements.options.querySelector(`[data-qv-opt-current="${index}"]`);
      if (labelSpan) labelSpan.textContent = value;
      updatePrice();
      updateAvailability();
    }
  }

  function updatePrice() {
    const v = currentVariant;
    const sale = v.compare_at_price && v.compare_at_price > v.price;
    let html = '';
    if (sale) {
      const diff = v.compare_at_price - v.price;
      const percent = Math.round((diff * 100) / v.compare_at_price);
      html = `
        <span class="qv-modal__price-compare">${formatMoney(v.compare_at_price)}</span>
        <span class="qv-modal__price-sale">${formatMoney(v.price)}</span>
        <span class="qv-modal__price-percent">-%${percent}</span>
      `;
    } else {
      html = `<span class="qv-modal__price">${formatMoney(v.price)}</span>`;
    }

    // Cart price preview (SEPETTE: X TL)
    const modal = getModal();
    const previewPercent = parseInt(modal?.dataset.cartPreviewPercent || '0', 10);
    if (previewPercent > 0) {
      const previewLabel = modal.dataset.cartPreviewLabel || 'SEPETTE';
      const previewColor = modal.dataset.cartPreviewColor || '#1F7A36';
      const previewPrice = Math.round(v.price * (100 - previewPercent) / 100);
      html += `
        <div class="qv-modal__price-preview" style="color: ${previewColor};">
          <span class="qv-modal__price-preview-label">${previewLabel}</span>
          <span class="qv-modal__price-preview-sep">:</span>
          <span class="qv-modal__price-preview-amount">${formatMoney(previewPrice)}</span>
        </div>
      `;
    }

    elements.priceRow.innerHTML = html;
  }

  function updateAvailability() {
    const v = currentVariant;
    if (v.available) {
      elements.atc.disabled = false;
      elements.atc.classList.remove('is-disabled');
      elements.atcLabel.textContent = 'Sepete Ekle';
      elements.inventory.hidden = true;
    } else {
      elements.atc.disabled = true;
      elements.atc.classList.add('is-disabled');
      elements.atcLabel.textContent = 'Tükendi';
      elements.inventory.textContent = 'Bu seçenek şu anda stokta yok.';
      elements.inventory.hidden = false;
    }
  }

  async function handleAddToCart() {
    if (!currentVariant) return;
    elements.atc.disabled = true;
    const originalLabel = elements.atcLabel.textContent;
    elements.atcLabel.textContent = 'Ekleniyor...';
    try {
      // POST with sections refresh (so cart drawer + bubble update server-side)
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: currentVariant.id, quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: '/cart'
        }),
      });
      if (!res.ok) {
        let errMsg = 'Sepete eklenemedi';
        try { const j = await res.json(); if (j.description) errMsg = j.description; } catch (_) {}
        throw new Error(errMsg);
      }
      const data = await res.json();

      // Refresh cart drawer DOM
      if (data.sections && data.sections['cart-drawer']) {
        try {
          const tmp = document.createElement('div');
          tmp.innerHTML = data.sections['cart-drawer'];
          const incoming = tmp.querySelector('cart-drawer');
          const current = document.querySelector('cart-drawer');
          if (incoming && current) {
            current.classList.toggle('is-empty', incoming.classList.contains('is-empty'));
            current.innerHTML = incoming.innerHTML;
          }
        } catch (e) { console.warn('cart-drawer refresh failed', e); }
      }

      // Refresh cart icon bubble (the count badge)
      if (data.sections && data.sections['cart-icon-bubble']) {
        try {
          const tmp = document.createElement('div');
          tmp.innerHTML = data.sections['cart-icon-bubble'];
          const incoming = tmp.querySelector('#cart-icon-bubble') || tmp.querySelector('[id*="cart-icon-bubble"]') || tmp.firstElementChild;
          const current = document.querySelector('#cart-icon-bubble') || document.querySelector('[id*="cart-icon-bubble"]');
          if (incoming && current) current.innerHTML = incoming.innerHTML;
        } catch (e) { console.warn('cart-icon-bubble refresh failed', e); }
      }

      elements.atcLabel.textContent = 'Sepete eklendi ✓';
      document.dispatchEvent(new CustomEvent('cart:added', { detail: { variantId: currentVariant.id } }));

      // Close quick view + open cart drawer immediately
      elements.atcLabel.textContent = originalLabel;
      elements.atc.disabled = false;
      closeModal();
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          cartDrawer.classList.add('active');
          cartDrawer.removeAttribute('hidden');
          document.body.classList.add('overflow-hidden');
        }
      }
    } catch (e) {
      console.error('Quick view add to cart error:', e);
      elements.atcLabel.textContent = (e && e.message) || 'Hata, tekrar dene';
      setTimeout(() => {
        elements.atcLabel.textContent = originalLabel;
        elements.atc.disabled = false;
      }, 1800);
    }
  }

  async function handleClick(handle, productUrl) {
    const m = getModal();
    if (!m) return;
    openModal();
    elements.content.hidden = true;
    elements.footer.hidden = true;
    elements.loading.hidden = false;
    try {
      const product = await fetchProduct(handle);
      renderProduct(product, productUrl);
      elements.loading.hidden = true;
      elements.content.hidden = false;
      elements.footer.hidden = false;
    } catch (err) {
      console.error('Quick view failed:', err);
      elements.loading.innerHTML = '<p>Ürün yüklenemedi. Lütfen detay sayfasını ziyaret edin.</p>';
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-quick-view]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const handle = btn.dataset.quickView;
    const productUrl = btn.dataset.productUrl || `/products/${handle}`;
    if (handle) handleClick(handle, productUrl);
  });
})();
